module.exports = __webpack_public_path__ + "static/media/wall10.d1438bad.jpeg";